<template lang="pug">
v-container.pa-0.View.View--Profile
  template(v-if="!loading")
    template(v-if="tickets.length")
      template(v-for="ticket in tickets")
        .white
            .Reservation.pa-3.px-3.cursor-pointer(@click="$router.push({ name: 'ticket', params: { ticket: ticket.id } })")
              .d-flex.flex-wrap.align-center
                div.mr-3
                  v-img.rounded(:src="ticket.location.coverImage" width="3rem" height="3rem")
                div.flex-grow-1
                  .subtitle-1 {{ ticket.location.name }}
                  div # {{ ticket.number }}
                div.text-right.flex-grow-1
                  template(v-if="ticket.beforeYou == 0")
                    div.font-weight-bold.success--text Tocca a te
                  template(v-else)
                    div.font-weight-bold.warning--text {{ ticket.beforeYou }} prima di te
                  div fra {{ formatWaitTime(ticket.estimatedArrivalDate) }}
            v-divider
    template(v-else)
      v-card
        v-card-text
          div Qui potrai vedere le tue prenotazioni.
          div Non ne hai ancora fatta una, la tua lista è vuota.
  template(v-else)
    Loading
</template>

<script>
import Ticket from "@/api/TicketPublic";
import Loading from "@/components/Loading";

import { delayToColor, waitToColor, formatWaitTime } from "@/utils/delayUtils";

export default {
  name: "ReservationHistory",
  components: { Loading },
  data: function() {
    return {
      loading: true,
      tickets: []
    };
  },

  async mounted() {
    this.loading = true;
    this.$emit("update:title", "Le tue prenotazioni");
    this.tickets = await Ticket.getUserTickets();
    this.loading = false;
  },

  methods: {
    delayToColor,
    waitToColor,
    formatWaitTime,

    minutesToDate(date) {
      const diff = date - new Date();
      return Math.floor(diff / 1000 / 60);
    }
  }
};
</script>
